import parseBindings from '../../parsebindings/index.js';
import bindNode from '../../bindnode/index.js';
import releaseNode from './releasenode.js';
import renderedNodes from './renderednodes.js';
import triggerOne from '../../trigger/_triggerone.js';
import initMK from '../../_core/init.js';
import defs from '../../_core/defs.js';
import matreshkaError from '../../_helpers/matreshkaerror.js';
import getNodes from '../../bindnode/_getnodes.js';
import objectValues from '../../_helpers/objectvalues.js';
var htmlTestReg = /</;
// when an item was rendered by an array and then removed from it, its sandbox still points to the removed node
// release that node so the item can be rendered again
function releaseStaleSandbox(item, itemDef, renderedInArrays, eventOptions) {
  var _itemDef$props$sandbo;
  var bindings = (_itemDef$props$sandbo = itemDef.props.sandbox) == null ? void 0 : _itemDef$props$sandbo.bindings;
  var sandbox = bindings == null ? void 0 : bindings[0].node;
  if (sandbox && renderedNodes.has(sandbox) && objectValues(renderedInArrays).indexOf(sandbox) === -1) {
    releaseNode(item, itemDef, sandbox, eventOptions);
  }
}
// the function makes the main rendering job
// it renders given array item
export default function renderItemNode(_ref) {
  var selfDef = _ref.selfDef,
    self = _ref.self,
    item = _ref.item,
    eventOptions = _ref.eventOptions;
  var renderer = item.renderer,
    _item$bindRenderedAsS = item.bindRenderedAsSandbox,
    bindRenderedAsSandbox = _item$bindRenderedAsS === void 0 ? true : _item$bindRenderedAsS;
  var itemRenderer = self.itemRenderer;
  var usedRenderer = renderer || itemRenderer;
  var rendererContext = usedRenderer === renderer ? item : self;
  var selfId = selfDef.id;
  var moveSandbox = eventOptions.moveSandbox,
    forceRerender = eventOptions.forceRerender,
    silent = eventOptions.silent;
  // if renderer is not found return null as a node; the node rendered before is dropped, so sorting
  // doesn't bring it back
  if (!usedRenderer) {
    var _oldDef$renderedInArr;
    var oldDef = defs.get(item);
    var oldNode = oldDef == null || (_oldDef$renderedInArr = oldDef.renderedInArrays) == null ? void 0 : _oldDef$renderedInArr[selfId];
    if (oldDef && oldNode) {
      var _oldDef$renderedInArr2;
      releaseNode(item, oldDef, oldNode, eventOptions);
      (_oldDef$renderedInArr2 = oldDef.renderedInArrays) == null || delete _oldDef$renderedInArr2[selfId];
    }
    return {
      node: null
    };
  }
  var itemDef = initMK(item);
  var _itemDef$renderedInAr = itemDef.renderedInArrays,
    renderedInArrays = _itemDef$renderedInAr === void 0 ? {} : _itemDef$renderedInAr;
  // if moveSandbox option is truthy then return a sandbox of an item
  if (moveSandbox) {
    var sandboxPropDef = itemDef.props.sandbox;
    if (sandboxPropDef) {
      var bindings = sandboxPropDef.bindings;
      var _node = bindings ? bindings[0].node : null;
      if (_node) {
        for (var i = 0, keys = Object.keys(renderedInArrays); i < keys.length; i++) {
          var key = keys[i];
          if (_node === renderedInArrays[key]) {
            // delete an information about previous array
            delete renderedInArrays[key];
            break;
          }
        }
        renderedInArrays[selfId] = _node;
        // moving sandbox does not fire "render" event but it fire "afterrender"
        // since "afterrender" means "node is inserted to DOM"
        return {
          node: _node.__replacedByNode || _node,
          itemEventOptions: {
            node: _node,
            self: item,
            parentArray: self
          }
        };
      }
    }
  }
  itemDef.renderedInArrays = renderedInArrays;
  if (forceRerender && renderedInArrays[selfId]) {
    // drop the bindings to the node which is going to be replaced
    releaseNode(item, itemDef, renderedInArrays[selfId], eventOptions);
  } else if (bindRenderedAsSandbox) {
    releaseStaleSandbox(item, itemDef, renderedInArrays, eventOptions);
  }
  // if usedRenderer is function then call it
  if (typeof usedRenderer === 'function') {
    usedRenderer = usedRenderer.call(rendererContext, item);
  }
  // if usedRenderer is string
  if (typeof usedRenderer === 'string') {
    if (!htmlTestReg.test(usedRenderer)) {
      // if usedRenderer is a selector
      var selector = usedRenderer;
      usedRenderer = getNodes(self, selector);
      if (usedRenderer.length) {
        // if a node is found by given selector then use its HTML
        usedRenderer = usedRenderer[0].innerHTML.trim();
      } else {
        // if not throw an error
        throw matreshkaError('array:renderer_node_missing', {
          selector: selector
        });
      }
    } else {
      // if usedRenderer is HTML string
      usedRenderer = usedRenderer.trim();
    }
  }
  // pass a node or HTML
  var parsed = parseBindings(item, usedRenderer, eventOptions);
  // if parseBindings returned more/less than one node then throw an error
  if (parsed.length !== 1) {
    throw matreshkaError('array:rendered_number_nodes', {
      length: parsed.length
    });
  }
  var node = parsed[0];
  renderedInArrays[selfId] = node;
  renderedNodes.set(node, true);
  if (bindRenderedAsSandbox) {
    bindNode(item, 'sandbox', node, null, eventOptions);
  }
  // if silent is not truthy then fire 'render' event and virtual methods
  if (!silent) {
    var itemEventOptions = {
      node: node,
      self: item,
      parentArray: self
    };
    var onRender = item.onRender;
    var onItemRender = self.onItemRender;
    if (onRender) {
      onRender.call(item, itemEventOptions);
    }
    if (onItemRender) {
      onItemRender.call(self, item, itemEventOptions);
    }
    triggerOne(item, 'render', itemEventOptions);
    return {
      node: node.__replacedByNode || node,
      itemEventOptions: itemEventOptions
    };
  }
  return {
    node: node.__replacedByNode || node
  };
}